import { call, put } from 'redux-saga/effects';

import {
  GET_USER_NOTIFICATIONS_SUCCESS,
  GET_USER_NOTIFICATIONS_ERROR,
  PUT_FAVOURITE_USER_NOTIFICATION_SUCCESS,
  PUT_FAVOURITE_USER_NOTIFICATION_ERROR,
  DISABLE_LOAD_MORE,
} from './actions';
import {
  fetchUserNotifications,
  updateNotification,
  fetchUserNotificationsWhatsNew,
  updateNotifications,
} from '../services/notificationsService';
import { categoriesIds } from '../constants/categories';
import { getUnreadIds } from '../utils';

const getCategoryFetchFunction = category => {
  switch (category) {
    case categoriesIds.yourNotifications:
      return fetchUserNotifications;
    case categoriesIds.whatsNew:
      return fetchUserNotificationsWhatsNew;
    case categoriesIds.yourDownloads:
      return fetchUserNotifications;
    case categoriesIds.uploada:
      return fetchUserNotifications;
    default:
      return undefined;
  }
};

export function* fetchUserNotificationsSaga({ payload }) {
  try {
    const { filter, category, page, limit } = payload;
    const baseParams = {
      page,
      limit,
      filter: JSON.stringify(filter),
    };

    let response = [];
    try {
      response = yield call(getCategoryFetchFunction(category), baseParams);
    } catch (err) {
      response = err;
    }

    if (response.length < limit) {
      yield put({ type: DISABLE_LOAD_MORE });
    }

    yield put({ type: GET_USER_NOTIFICATIONS_SUCCESS, payload: response });

    const unreadIds = getUnreadIds(response);

    if (unreadIds.length) {
      yield call(updateNotifications, { data: unreadIds });
    }
  } catch (error) {
    yield put({ type: GET_USER_NOTIFICATIONS_ERROR });
  }
}

export function* putFavouriteUserNotificationSaga({ payload }) {
  try {
    const { id, isFavourite } = payload;

    yield call(updateNotification, { id, data: { is_favourite: isFavourite } });
    yield put({ type: PUT_FAVOURITE_USER_NOTIFICATION_SUCCESS, payload });
  } catch (error) {
    yield put({ type: PUT_FAVOURITE_USER_NOTIFICATION_ERROR, payload });
  }
}
